import { stateOptions } from '../commonStateTaxData';

export const step1InitialQuestions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const maritalStatusQuestion = [
  {
    id: 'filing_status',
    title: 'Marital status (Line 3)',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married_filing_jointly_both_spouses_working',
        shortName: 'Married filing jointly, both spouses working',
      },
      {
        codeValue: 'married_filing_jointly_one_spouse_working',
        shortName: 'Married filing jointly, one spouse working',
      },
      {
        codeValue: 'married_filing_separately',
        shortName: 'Married filing separately',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of Household',
      },
    ],
  },
];

export const maritalStatusAllowancesOptions = {
  single: [
    {
      id: 'total_number_of_allowances',
      title: 'Please select number of allowances you wish to claim. If you do not wish to claim an allowance, select 0 allowances for your marital status.',
      question_type: 'multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '0_allowances',
          shortName: '0 allowances',
        },
        {
          codeValue: '1_allowances',
          shortName: '1 allowances',
        },
      ],
    },
  ],
  married_filing_jointly_both_spouses_working: [
    {
      id: 'total_number_of_allowances',
      title: 'Please select number of allowances you wish to claim. If you do not wish to claim an allowance, select 0 allowances for your marital status.',
      question_type: 'multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '0_allowances',
          shortName: '0 allowances',
        },
        {
          codeValue: '1_allowances',
          shortName: '1 allowances',
        },
      ],
    },
  ],
  married_filing_separately: [
    {
      id: 'total_number_of_allowances',
      title: 'Please select number of allowances you wish to claim. If you do not wish to claim an allowance, select 0 allowances for your marital status.',
      question_type: 'multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '0_allowances',
          shortName: '0 allowances',
        },
        {
          codeValue: '1_allowances',
          shortName: '1 allowances',
        },
      ],
    },
  ],
  head_of_household: [
    {
      id: 'total_number_of_allowances',
      title: 'Please select number of allowances you wish to claim. If you do not wish to claim an allowance, select 0 allowances for your marital status.',
      question_type: 'multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '0_allowances',
          shortName: '0 allowances',
        },
        {
          codeValue: '1_allowances',
          shortName: '1 allowances',
        },
      ],
    },
  ],
  married_filing_jointly_one_spouse_working: [
    {
      id: 'total_number_of_allowances',
      title: 'Please select number of allowances you wish to claim. If you do not wish to claim an allowance, select 0 allowances for your marital status.',
      question_type: 'multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '0_allowances',
          shortName: '0 allowances',
        },
        {
          codeValue: '1_allowances',
          shortName: '1 allowances',
        },
        {
          codeValue: '2_allowances',
          shortName: '2 allowances',
        },
      ],
    },
  ],
};

export const deductionQuestion = [
  {
    id: 'deduction',
    title: 'Are you claiming the Georgia standard deduction or using itemized deductions?',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'georgia_standard_deduction',
        shortName: 'Georgia standard deduction',
      },
      {
        codeValue: 'itemized_deduction',
        shortName: 'Itemized deduction',
      },
    ],
  },
];

export const worksheetDeductionQuestions1223 = [
  {
    id: 'itemized_deduction_value',
    title: 'Federal estimated itemized deductions (if itemizing deductions) - Step 5(A)',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'georgia_standard_deduction',
    title: 'Georgia Standard Deduction (enter one) - Step 5(B): ',
    question_type: 'multiple_choice',
    is_required: true,
    options: [
      {
        codeValue: 'single_head_of_household',
        shortName: 'Single/Head of Household - $12,000',
      },
      {
        codeValue: 'married_filing_joint',
        shortName: 'Married Filing Joint - $24,000',
      },
      {
        codeValue: 'married_filing_separate',
        shortName: 'Married Filing Separate - $12,000',
      },
    ],
  },
  {
    id: 'allowable_deductions_to_federal_adjusted_gross_income',
    title: 'Allowable Georgia Adjustments to Federal Adjusted Gross Income - Step 5(D)',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'estimate_of_taxable_income',
    title: 'Estimate of taxable income not Subject to Withholding - Step 5(F)',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const worksheetDeductionQuestions = {
  georgia_standard_deduction: [
    {
      id: 'self_age_blindness',
      title: 'Yourself: ',
      question_type: 'multiple_selection',
      options: [
        {
          codeValue: 'yourself_age_65',
          shortName: 'Age 65 or over',
        },
        {
          codeValue: 'yourself_blind',
          shortName: 'Blind',
        },
      ],
    },
    {
      id: 'spouse_age_blindness',
      title: 'Spouse: ',
      question_type: 'multiple_selection',
      options: [
        {
          codeValue: 'spouse_age_65',
          shortName: 'Age 65 or over',
        },
        {
          codeValue: 'spouse_blind',
          shortName: 'Blind',
        },
      ],
    },
    {
      id: 'standard_deduction_type',
      title: 'Select a Georgia standard deduction',
      is_required: true,
      question_type: 'multiple_choice',
      options: [
        {
          codeValue: 'single_head_of_household',
          shortName: 'Single/head of household - $4,600',
        },
        {
          codeValue: 'married_one_spouse',
          shortName: 'Married, one spouse - $3,000',
        },
        {
          codeValue: 'married_both_spouses',
          shortName: 'Married, both spouses - $6,000',
        },
      ],
    },
  ],
  itemized_deduction: [
    {
      id: 'itemized_deduction_value',
      title: 'Federal estimated itemized deductions (if itemizing deductions)',
      is_required: true,
      question_type: 'short_text',
      rules: [
        {
          category: 'regex',
          action: 'match',
          value: '^(0|[1-9][0-9]*)$',
        },
      ],
    },
  ],
};

export const worksheetCommonDeductionQuestions = [
  {
    id: 'allowable_deductions_to_federal_adjusted_gross_income',
    title: 'Allowable deductions to federal adjusted gross income',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'estimate_of_taxable_income',
    title: 'Estimate of taxable income not subject to withholding',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const allowancesQuestionsPartTwo = [
  {
    id: 'additional_withholding_amount',
    title: 'Additional withholding amount per pay period, if any',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const additionalWithholdingQn1223 = [
  {
    id: 'additional_withholding_amount',
    title: 'Additional withholding (Line 6)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const exemptionInitialQuestions = [
  {
    id: 'exemption_from_withholding',
    title: 'Exemption from withholding',
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'incurred_no_income_tax_liability',
        shortName: 'I claim exemption from withholding because I incurred no Georgia income tax liability last year and I do not expect to have a Georgia income tax liability this year.',
      },
      {
        codeValue: 'civil_relief_act',
        shortName: 'I certify that I am not subject to Georgia withholding because I meet the conditions set forth under the Servicemembers Civil Relief Act.',
      },
    ],
  },
];

export const civilReliefActStateQuestion = [
  {
    id: 'state_of_residence',
    title: 'Select your state of residence and your spouse\'s (servicemember) state of residence. The states of residence must be the same to be exempt.',
    question_type: 'dropdown',
    options: stateOptions,
  },
];
